import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class PrintFolders {
  constructor(
    public pathName: string,
    public objectType: string,
    public creationDateTime: moment.Moment,
    public lastDateTime: moment.Moment,
    public dataSize: number
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class PrintFoldersAdapter implements Adapter<PrintFolders> {
  adapt(item: any): PrintFolders {
    return new PrintFolders(
      item.PATH_NAME,
      item.OBJECT_TYPE,
      item.CREATE_TIMESTAMP,
      item.LAST_USED_TIMESTAMP,
      item.DATA_SIZE
    );
  }
}
